import { render, staticRenderFns } from "./batchSetkeyWord.vue?vue&type=template&id=d69faaba&"
import script from "./batchSetkeyWord.vue?vue&type=script&lang=js&"
export * from "./batchSetkeyWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports